// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ttd-health-audiences .st-table .st-table__cell{white-space:unset}", "",{"version":3,"sources":["webpack://./src/js/pages/ttd-health-audiences/styles.scss"],"names":[],"mappings":"AACE,gDACE,iBAAA","sourcesContent":[".ttd-health-audiences {\n  .st-table .st-table__cell {\n    white-space: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
